import Image from "next/image";
import Link from "next/link";
import { useState } from "react";
import styles from "./index.module.scss";

const OpenSeaBtn = ({ href }: { href: string }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Link href={href} passHref>
      <a
        target="_blank"
        rel="noopener noreferrer"
        className={styles.button}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        {isHovered ? (
          <Image
            src="/images/colored-opensea.png"
            alt="opensea"
            layout="fill"
            objectFit="contain"
          />
        ) : (
          <div className="w-[24px] h-[24px] flex justify-center items-center">
            <Image
              src="/images/opensea.png"
              alt="opensea"
              width="24"
              height="24"
            />
          </div>
        )}
      </a>
    </Link>
  );
};

export default OpenSeaBtn;
